<div
	(backdropClick)="isLaneDetailsProfileView = !isLaneDetailsProfileView"
	class="app-default-background h-100"
	mat-sidenav-container
>
	<mat-sidenav
		(keydown.escape)="isLaneDetailsProfileView = !isLaneDetailsProfileView"
		[fixedInViewport]="true"
		[mode]="'side'"
		[opened]="isLaneDetailsProfileView"
		[position]="'end'"
		class="app-default-background zIndex-20"
		[ngClass]="{
			fixed_tab_header: !isLaneDetailsProfileView,
		}"
		disableClose
	>
		<app-lane-details
			(closeLaneDetails)="isLaneDetailsProfileView = false"
			[carrierLaneData]="carrierLaneData"
			[recentFeedbackList]="recentFeedbackList"
			[openedMatch]="openedQualityObject"
		>
		</app-lane-details>
	</mat-sidenav>

	<div mat-sidenav-content class="h-100">
		<!-- CN-8312: Collapsible layout - also used for Workflow projects (which never use Kanban) -->
		<div class="page_container_default h-100 v2-layout-active" *ngIf="!useLayoutV3 || isWaterfallOrDedicatedLaneProject">
			<div fxLayout="row" fxLayoutGap="1rem" #pageContentContainer *ngIf="pageContentAfterViewInit">
				<div class="content-container" fxFlex="74">
					<div
						#projectDetailsAndPricingContainer
						class="zIndex-10"
						stickybits
						*ngIf="pageContentAfterViewInit"
					>
						<div class="full-width">
							<div
								*ngIf="projectDetailsStore.projectDTO$ | async; else projectDetailSkeletonLoader"
								fxFlex="100"
							>
								<div>
									<!-- CN-8312: Collapsible header - the only non-Kanban layout -->
									<app-project-specifications-v2
										(updateProjectEvent)="
											updateProject(false, 'Project updated successfully.', $event)
										"
										[isUpdatingProject]="isUpdatingProject"
										[project]="projectDetailsStore.projectDTO$ | async"
										[projectGroups]="projectDetailsStore.projectGroups$ | async"
										class="full-width"
									>
									</app-project-specifications-v2>
								</div>
							</div>
						</div>
						<div
							class="full-width m-t-0-5 m-b-0-5 v2-pricing-section"
							*ngIf="
								showPricingAndRecentTransactions() &&
								(projectDetailsStore.searchTruckForm$ | async) as searchTruckForm
							"
						>
							<app-pricing
								*ngIf="searchTruckForm"
								#pricingComponent
								(lanePricingCompleted)="lanePricingCompleted($event)"
								(pricingFeedbackSubmitted)="resetNoOfSearchesWithoutFeedbackCounter()"
								[inOpportunitiesPage]="true"
								[searchTruckForm]="searchTruckForm"
								[v1PricingLayout]="false"
								[greenScreensEnabled]="greenScreensEnabled"
								[sonarEnabled]="sonarEnabled"
								class="full-width"
							>
							</app-pricing>
						</div>
					</div>

					<ng-template [ngTemplateOutlet]="recommendedAndProcuredTab"></ng-template>
				</div>

				<div class="content-container" fxFlex="25">
					<div
						*ngIf="{
							projectDTO: projectDetailsStore.projectDTO$ | async,
							searchTruckForm: projectDetailsStore.searchTruckForm$ | async,
						} as store"
						class="h-100 full-width"
					>
						<!-- CN-8770: this flex column needs min-width:0 to shrink to its 25% parent (max-width) instead of overflowing the viewport when the Quality/Notes content is wide (flexbox min-width:auto trap). min-width MUST come from a CSS class, not an inline style: Angular Flex-Layout (fxLayout/fxFlex) rewrites this element's inline style attribute at runtime and wipes any static inline min-width. See .pd-right-column-flex in the component scss. -->
						<div fxLayout="column" fxFlex class="pd-right-column-flex">
							<div
								class="hide_scrollbar_in_container overflow_visible quality_tab_container"
								*ngIf="accountSettings.CARRIER_QUALITY"
							>
								<div fxLayout="row">
									<mat-tab-group
										class="custom-tab h-100 full-width disable_tab_header_transition"
										dynamicHeight
										[@.disabled]="true"
										[ngClass]="{
											fixed_tab_header: !isLaneDetailsProfileView,
										}"
									>
										<mat-tab>
											<ng-template matTabLabel>
												<span>Quality</span>
											</ng-template>
											<app-quality
												class="full-width"
												*ngIf="
													carrierIdsToFetchNotes.length === 1 &&
													(projectDetailsStore.allProjectCarrierMapsList$
														| async) as allProjectCarrierMapsList
												"
												[carrierId]="carrierIdsToFetchNotes[0]"
												[destinationCity]="projectDTO?.destCity"
												[destinationState]="projectDTO?.destState"
												[originCity]="projectDTO?.originCity"
												[originState]="projectDTO?.originState"
												[mc]="getCarrierMc(allProjectCarrierMapsList)"
												[dot]="getCarrierDot(allProjectCarrierMapsList)"
												[isCarrierInNetwork]="getIsCarrierInNetwork(allProjectCarrierMapsList)"
												[carrierActive]="true"
												[ccBookingRateDisplay]="
													getCarrierQuality(allProjectCarrierMapsList)?.ccBookingRateDisplay
												"
												[ccEngagementRateDisplay]="
													getCarrierQuality(allProjectCarrierMapsList)?.ccEngagementRateDisplay
												"
												[ccFalloffRateDisplay]="
													getCarrierQuality(allProjectCarrierMapsList)?.ccFalloffRateDisplay
												"
												[ccTotalBookedLoads]="
													getCarrierQuality(allProjectCarrierMapsList)?.ccTotalBookedLoads
												"
												[ccScore]="getCarrierQuality(allProjectCarrierMapsList)?.ccScore"
												[vettingOverallDisplay]="vettingOverallDisplay(allProjectCarrierMapsList)"
												[vettingAuthorityDisplay]="
													vettingAuthorityDisplay(allProjectCarrierMapsList)
												"
												[vettingInsuranceDisplay]="
													vettingInsuranceDisplay(allProjectCarrierMapsList)
												"
												[vettingOperationsDisplay]="
													vettingOperationsDisplay(allProjectCarrierMapsList)
												"
												[vettingSafetyDisplay]="vettingSafetyDisplay(allProjectCarrierMapsList)"
												[vettingOtherDisplay]="vettingOtherDisplay(allProjectCarrierMapsList)"
												[infractionDetails]="infractionDetails(allProjectCarrierMapsList)"
												[lastVettingTime]="getLastVettingTime(allProjectCarrierMapsList)"
											>
											</app-quality>
											<mat-card
												*ngIf="carrierIdsToFetchNotes.length > 1"
												class="m-t-1 primary-text font-size-17"
												fxFlex="100"
												fxLayoutAlign="center center"
											>
												Quality score is available for a single selected carrier
											</mat-card>

											<app-quality-stats
												*ngIf="
													!carrierIdsToFetchNotes.length &&
													(tabGroup?.selectedIndex == 0
														? true
														: !(projectDetailsStore.loadingProjectCarrierMaps$ | async))
												"
												class="full-width"
												[capacitySearchResult]="onRecommendedTab"
												[engagedProjectCarrierMap]="onEngagedTab"
												[procuredProjectCarrierMap]="onProcuredTab"
												[capacitySearchList]="
													recommendedCarriersComponent?.pannelWrapperComponent
														?.capacitySearchResults
												"
												[projectCarrierMapsList]="
													onEngagedTab
														? (projectDetailsStore.engagedCarriersList$ | async)
														: procuredTabCarriersList
												"
											>
											</app-quality-stats>
										</mat-tab>
									</mat-tab-group>
								</div>
							</div>

							<div
								fxFlex
								class="zIndex-10 app-default-background hide_scrollbar_in_container overflow_scroll"
								[stickyOffset]="0"
								stickybits
								style="height: inherit"
							>
								<div fxLayout="row">
									<mat-tab-group
										class="custom-tab h-100 full-width disable_tab_header_transition"
										dynamicHeight
										[@.disabled]="true"
										[ngClass]="{
											fixed_tab_header: !isLaneDetailsProfileView,
										}"
									>
										<mat-tab>
											<ng-template matTabLabel>
												<span>Notes</span>
												<span
													[matBadge]="totalNumberOfNotes"
													class="ml-6 custom-badge"
													matBadgeOverlap="false"
												></span>
											</ng-template>
											<div
												*ngIf="
													store.projectDTO?.id && store.searchTruckForm;
													else notesSkeletonLoader
												"
											>
												<div
													*ngIf="carrierIdsToFetchNotes.length > 1"
													class="font-size-13 label-text-light pt-2"
													fxLayout="row"
													fxLayoutAlign="start center"
												>
													Notes can be listed for a single selected carrier or the Projects
												</div>
												<div style="overflow-y: scroll; max-height: 100vh">
													<div *ngFor="let carrier of carrierIdsToFetchNotes | slice: 0 : 1">
														<app-note-list
															*ngIf="carrierIdsToFetchNotes.length === 1"
															(noteCountUpdated)="totalNumberOfNotes = $event"
															[noteType]="getNoteType()"
															[id]="carrier"
															[name]="null"
															[supportId]="store.projectDTO.id"
															[showFeedback]="false"
															[refreshTrigger]="notesRefreshTrigger"
														></app-note-list>
													</div>
													<app-note-list
														*ngIf="carrierIdsToFetchNotes.length !== 1"
														(noteCountUpdated)="totalNumberOfNotes = $event"
														[noteType]="getNoteType()"
														[id]="store.projectDTO.id"
														[name]="store.projectDTO.name"
														[refreshTrigger]="notesRefreshTrigger"
													></app-note-list>
												</div>
											</div>
										</mat-tab>
										<mat-tab *ngIf="productsService.TASKS">
											<ng-template matTabLabel>
												<span>Tasks</span>
												<span
													[matBadge]="totalNumberOfTasks"
													class="ml-6 custom-badge"
													matBadgeOverlap="false"
												></span>
											</ng-template>
											<div *ngIf="!utilService.isNullOrUndefined(projectId)" fxLayout="row">
												<app-tasks-infinite-scroll
													(totalNumberOfTasks)="totalNumberOfTasks = $event"
													[projectDTO]="projectDetailsStore.projectDTO$ | async"
													[projectId]="projectId"
													fxFlex="100"
												></app-tasks-infinite-scroll>
											</div>
										</mat-tab>
									</mat-tab-group>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- CN-8312: V3 Layout - Ribbon Menu (disabled for Workflow projects) -->
		<div class="v3-layout-container" *ngIf="useLayoutV3 && !isWaterfallOrDedicatedLaneProject">
			<!-- Main content area - full width minus ribbon -->
			<div class="v3-main-content">
				<!-- V3 Compact Lane Bar - Click to open Project Details tray -->
				<div class="v3-lane-bar" *ngIf="projectDetailsStore.projectDTO$ | async as project" (click)="onRibbonItemClicked('project')">
					<div class="lane-bar-route">
						<span class="lane-origin">{{ project.originCity }}, {{ project.originState | stateDisplay }}</span>
						<mat-icon class="lane-arrow">arrow_forward</mat-icon>
						<span class="lane-dest">{{ project.destCity }}, {{ project.destState | stateDisplay }}</span>
						<span class="lane-equipment" *ngIf="project.equipmentType">({{ project.equipmentType }})</span>
					</div>
					<div class="lane-bar-details">
						<span class="lane-detail" *ngIf="project.customerDTO?.name">
							<span class="detail-label">Customer:</span> {{ project.customerDTO.name }}
						</span>
						<span class="lane-detail">
							<span class="detail-label">Max Buy:</span> {{ project.maxBuy | currency:'USD':'symbol':'1.0-0' }}
						</span>
						<span class="lane-detail" *ngIf="project.assignee?.firstName">
							<span class="detail-label">Assigned:</span> {{ project.assignee.firstName }} {{ project.assignee.lastName }}
						</span>
					</div>
					<mat-icon class="lane-bar-expand">chevron_right</mat-icon>
				</div>

				<!-- Pricing section -->
				<div
					class="v3-pricing-section"
					*ngIf="
						showPricingAndRecentTransactions() &&
						(projectDetailsStore.searchTruckForm$ | async) as searchTruckForm
					"
				>
					<app-pricing
						*ngIf="searchTruckForm"
						#pricingComponent
						(lanePricingCompleted)="lanePricingCompleted($event)"
						(pricingFeedbackSubmitted)="resetNoOfSearchesWithoutFeedbackCounter()"
						[inOpportunitiesPage]="true"
						[searchTruckForm]="searchTruckForm"
						[v1PricingLayout]="false"
						[greenScreensEnabled]="greenScreensEnabled"
						[sonarEnabled]="sonarEnabled"
						class="full-width"
					>
					</app-pricing>
				</div>

				<!-- V3 Kanban Layout - All columns visible -->
				<div class="v3-carrier-section">
					<!-- Filter/Sort/Actions bar -->
					<div class="v3-kanban-actions" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="0.5rem">
						<button
							mat-raised-button
							color="primary"
							[mtxPopoverTriggerFor]="capacitySearchFiltersPopover"
							mtxPopoverTriggerOn="click"
						>
							FILTER<span>{{ filterIndicator }}</span>
							<mat-icon>expand_more</mat-icon>
						</button>

						<button
							mat-raised-button
							color="primary"
							[mtxPopoverTriggerFor]="capacitySearchSortPopover"
							mtxPopoverTriggerOn="click"
						>
							SORT
							{{
								carrierFiltersModel.capacitySearchSort === 'match'
									? '(BEST Match)'
									: carrierFiltersModel.capacitySearchSort === 'quality'
										? '(Quality)'
										: '(Frequency)'
							}}
							<mat-icon>expand_more</mat-icon>
						</button>

						<button
							mat-raised-button
							color="primary"
							[matMenuTriggerFor]="v3KanbanActions"
						>
							ACTIONS
							<mat-icon>expand_more</mat-icon>
						</button>
						<mat-menu #v3KanbanActions="matMenu" class="cc_menu_container">
							<button (click)="selectAllCarriers()" color="primary" mat-menu-item>
								Select All Carriers
							</button>
							<button (click)="downloadCapacitySearchResultsCsv()" color="primary" mat-menu-item>
								Export
							</button>
							<button
								(click)="utilService.navigateToCapacitySearch(projectDTO)"
								color="primary"
								mat-menu-item
								[disabled]="!(recommendedCarriersStore.hasLane$ | async)"
							>
								Search Capacity
							</button>
						</mat-menu>
					</div>

					<!-- Kanban Columns -->
					<div class="v3-kanban-container" fxLayout="row" fxLayoutGap="1rem">
						<!-- Recommended Column -->
						<div class="v3-kanban-column" fxFlex>
							<div class="v3-kanban-column-header">
								<span class="column-title">Recommended</span>
								<span
									*ngIf="!(recommendedCarriersStore.loadingLanesList$ | async)"
									class="column-badge"
								>
									{{ recommendedCarriersComponent?.pannelWrapperComponent?.capacitySearchResults?.length || 0 }}
								</span>
								<mat-spinner
									*ngIf="recommendedCarriersStore.loadingLanesList$ | async"
									[diameter]="14"
								></mat-spinner>
							</div>
							<div
								class="v3-kanban-column-content"
								droppable
								(drop)="onRecommendedTabDrop($event)"
								[dragOverClass]="'dropHover'"
							>
								<div
									*ngIf="
										(projectDetailsStore.projectDTO$ | async) &&
										!(projectDetailsStore.loadingProjectCarrierMaps$ | async)
									"
									class="h-100"
								>
									<app-recommended-carriers
										#recommendedCarriersComponent
										(lanesCount)="NUMBER_OF_LANES = $event; populateSearchTruckForm()"
										(openLaneDetails)="openFullProfile($event, null)"
										(updateSelectedcarrierIds)="
											selectedCarrierIds = $event; populateCarrierIdsToFetchNotes()
										"
										(panelFocused)="onRecommendedPanelFocused($event)"
										[hideLastColumn]="true"
										[isKanbanView]="true"
										[minLoadsPerWeek]="carrierFiltersModel.minLoadsPerWeek"
										[projectDTO]="projectDetailsStore.projectDTO$ | async"
									></app-recommended-carriers>
								</div>
							</div>
						</div>

						<!-- Engaged Column -->
						<div
							class="v3-kanban-column"
							fxFlex
							*ngIf="environment.ENABLE_ENGAGED_TAB_ON_PROJECT_DETAILS"
						>
							<div class="v3-kanban-column-header">
								<span class="column-title">Engaged</span>
								<span class="column-badge">
									{{ (projectDetailsStore.engagedCarriersCount$ | async) || 0 }}
								</span>
							</div>
							<div
								class="v3-kanban-column-content"
								droppable
								(drop)="onEngagedTabDrop($event)"
								[dragOverClass]="'dropHover'"
							>
								<div *ngIf="projectDetailsStore.loadingProjectCarrierMaps$ | async">
									<app-skeleton-loader
										cssClasses="contaier_height_auto"
										[SHOW_PANEL]="true"
										[DEFAULT_ROWS_SIZE]="3"
									></app-skeleton-loader>
								</div>
								<div
									*ngIf="
										!(projectDetailsStore.loadingProjectCarrierMaps$ | async) &&
										(projectDetailsStore.engagedCarriersList$ | async).length === 0
									"
									class="v3-kanban-empty-state"
								>
									<mat-icon>group_add</mat-icon>
									<span>Drag carriers here to engage</span>
								</div>
								<app-procured-carriers
									*ngIf="!(projectDetailsStore.loadingProjectCarrierMaps$ | async)"
									#engagedCarriersComponent
									[enableOnboardCarrier]="true"
									(fireSegmentEvent)="
										fireSegmentEvent($event?.projectId, $event?.carrierId, $event?.cIndex)
									"
									(openFullProfileEvent)="
										openFullProfile($event?.projectCarrierMap, $event?.event)
									"
									(panelClicked)="panelClicked($event)"
									[hideLastColumn]="true"
									[isKanbanView]="true"
									[projectDTO]="projectDetailsStore.projectDTO$ | async"
									[accountCarrierLanes]="projectDetailsStore.accountCarrierLanes$ | async"
									[isCarrierRatesEnabled]="isCarrierRatesEnabled"
									[isLoadingAccountCarrierLanes]="
										projectDetailsStore.loadingAccountCarrierLanes$ | async
									"
									[projectCarrierMapList]="projectDetailsStore.engagedCarriersList$ | async"
									[searchTruckForm]="searchTruckForm"
									[selectedProjectCarrierMapIDs]="selectedProjectCarrierMapIDs"
									[usersList]="projectDetailsStore.usersList$ | async"
									[allUsersList]="allUsersList"
									[userCarrierMapList]="recommendedCarriersStore.userCarrierMapList$ | async"
									[userCarrierMap]="recommendedCarriersStore.userCarrierMap$ | async"
									[isCarrierVettingIntegrationEnabled]="isCarrierVettingIntegrationEnabled"
									[CARRIER_QUALITY_ENABLED]="CARRIER_QUALITY_ENABLED"
								></app-procured-carriers>
							</div>
						</div>

						<!-- Procured Column -->
						<div class="v3-kanban-column" fxFlex>
							<div class="v3-kanban-column-header">
								<span class="column-title">Procured</span>
								<span class="column-badge">
									{{ (projectDetailsStore.procuredCarriersCount$ | async) || 0 }}
								</span>
							</div>
							<div
								class="v3-kanban-column-content"
								droppable
								(drop)="onProcuredTabDrop($event)"
								[dragOverClass]="'dropHover'"
							>
								<div *ngIf="projectDetailsStore.loadingProjectCarrierMaps$ | async">
									<app-skeleton-loader
										cssClasses="contaier_height_auto"
										[SHOW_PANEL]="true"
										[DEFAULT_ROWS_SIZE]="3"
									></app-skeleton-loader>
								</div>
								<div
									*ngIf="
										(projectDetailsStore.procuredCarriersCount$ | async) === 0 &&
										(projectDetailsStore.procuredCarriersWithoutGroupCount$ | async) === 0 &&
										!(projectDetailsStore.loadingProjectCarrierMaps$ | async)
									"
									class="v3-kanban-empty-state"
								>
									<mat-icon>how_to_reg</mat-icon>
									<span>Drag carriers here to procure</span>
								</div>
								<div *ngIf="!(projectDetailsStore.loadingProjectCarrierMaps$ | async)">
									<div *ngIf="projectId">
										<app-project-groups
											#projectGroups
											(procuredCarriersSelectionUpdated)="procuredCarriersSelectionUpdated()"
											(openFullProfileEvent)="
												openFullProfile($event?.projectCarrierMap, $event?.event)
											"
											(editAllocationEvent)="editAllocation($event?.projectCarrierMap)"
											[isWorkflowProject]="false"
											[carrierAllocationsMap]="projectDetailsStore.carrierAllocationsMap$ | async"
										></app-project-groups>
									</div>
									<app-procured-carriers
										#procuredCarriersComponent
										(fireSegmentEvent)="
											fireSegmentEvent($event?.projectId, $event?.carrierId, $event?.cIndex)
										"
										(openFullProfileEvent)="
											openFullProfile($event?.projectCarrierMap, $event?.event)
										"
										(panelClicked)="panelClicked($event)"
										[hideLastColumn]="true"
										[isKanbanView]="true"
										[accountCarrierLanes]="projectDetailsStore.accountCarrierLanes$ | async"
										[isCarrierRatesEnabled]="isCarrierRatesEnabled"
										[isLoadingAccountCarrierLanes]="
											projectDetailsStore.loadingAccountCarrierLanes$ | async
										"
										[projectCarrierMapList]="projectDetailsStore.procuredCarriersList$ | async"
										[projectDTO]="projectDetailsStore.projectDTO$ | async"
										[searchTruckForm]="searchTruckForm"
										[selectedProjectCarrierMapIDs]="selectedProjectCarrierMapIDs"
										[usersList]="projectDetailsStore.usersList$ | async"
									[allUsersList]="allUsersList"
										[userCarrierMapList]="recommendedCarriersStore.userCarrierMapList$ | async"
										[userCarrierMap]="recommendedCarriersStore.userCarrierMap$ | async"
										[isCarrierVettingIntegrationEnabled]="isCarrierVettingIntegrationEnabled"
										[CARRIER_QUALITY_ENABLED]="CARRIER_QUALITY_ENABLED"
										[isWorkflowProject]="false"
										[carrierAllocationsMap]="projectDetailsStore.carrierAllocationsMap$ | async"
									></app-procured-carriers>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<!-- Ribbon Menu -->
			<app-ribbon-menu
				[menuItems]="ribbonMenuItems"
				[activeItem]="activeRibbonItem"
				[notesCount]="totalNumberOfNotes"
				[tasksCount]="totalNumberOfTasks"
				(itemClicked)="onRibbonItemClicked($event)"
			></app-ribbon-menu>

			<!-- Ribbon Tray -->
			<app-ribbon-tray
				[isOpen]="isRibbonTrayOpen"
				[title]="ribbonTrayTitle"
				(close)="closeRibbonTray()"
			>
				<!--
					Project Panel — keep mounted while the project is loaded and
					hide with [hidden] when the tray is showing a different ribbon
					item. Using *ngIf here would destroy the inherited
					ProjectSpecificationsComponent on every tab switch, dropping
					unsaved projectCopy edits and popover state. Mirrors the
					always-mounted Notes / Tasks pattern below.
				-->
				<app-project-details-panel
					*ngIf="(projectDetailsStore.projectDTO$ | async) as projectForPanel"
					[hidden]="activeRibbonItem !== 'project'"
					(updateProjectEvent)="updateProject(false, 'Project updated successfully.', $event)"
					[isUpdatingProject]="isUpdatingProject"
					[project]="projectForPanel"
					[projectGroups]="projectDetailsStore.projectGroups$ | async"
				></app-project-details-panel>

				<!--
					Notes Panel — keep app-note-list mounted whenever the project is
					loaded (toggle visibility with [hidden] instead of *ngIf) so the
					ribbon Notes badge is populated on initial load and refreshes when
					focus changes, even before the user opens this panel for the
					first time. The previous *ngIf="activeRibbonItem === 'notes'"
					meant the badge stayed blank until the panel was opened at least
					once because noteCountUpdated never fired.
				-->
				<div
					*ngIf="(projectDetailsStore.projectDTO$ | async) as project"
					class="tray-panel-content"
					[hidden]="activeRibbonItem !== 'notes'"
				>
					<div *ngIf="carrierIdsToFetchNotes.length > 1" class="font-size-13 label-text-light p-2">
						Notes can be listed for a single selected carrier or the Projects
					</div>
					<div *ngFor="let carrier of carrierIdsToFetchNotes | slice: 0 : 1">
						<app-note-list
							#trayCarrierNoteList
							*ngIf="carrierIdsToFetchNotes.length === 1"
							(noteCountUpdated)="totalNumberOfNotes = $event"
							[noteType]="getNoteType()"
							[id]="carrier"
							[name]="null"
							[supportId]="project.id"
							[showFeedback]="false"
							[refreshTrigger]="notesRefreshTrigger"
						></app-note-list>
					</div>
					<app-note-list
						*ngIf="carrierIdsToFetchNotes.length !== 1"
						(noteCountUpdated)="totalNumberOfNotes = $event"
						[noteType]="getNoteType()"
						[id]="project.id"
						[name]="project.name"
						[refreshTrigger]="notesRefreshTrigger"
					></app-note-list>
				</div>

				<!--
					Tasks Panel — same always-mounted pattern as Notes above so the
					ribbon Tasks badge stays in sync with the focused carrier without
					requiring the user to open the panel first. Gated on
					productsService.TASKS so accounts without the Tasks feature don't
					fire the tasks API (mirrors the V1/V2 mat-tab gate at line 266).
				-->
				<div
					*ngIf="productsService.TASKS && !utilService.isNullOrUndefined(projectId)"
					class="tray-panel-content"
					[hidden]="activeRibbonItem !== 'tasks'"
				>
					<app-tasks-infinite-scroll
						(totalNumberOfTasks)="totalNumberOfTasks = $event"
						[projectDTO]="projectDetailsStore.projectDTO$ | async"
						[projectId]="projectId"
						class="full-width"
					></app-tasks-infinite-scroll>
				</div>

				<!--
					Carrier Panel (ribbon id stays 'quality'). Surfaces the focused
					carrier's contact actions on top of the existing quality / vetting
					content. The CARRIER_QUALITY gate moved inward so the contact block
					still shows for accounts without carrier quality enabled.
				-->
				<div
					*ngIf="activeRibbonItem === 'quality'"
					class="tray-panel-content"
				>
					<!--
						Quality section — stays on top, labeled "Quality". Per-carrier
						quality + vetting when a single carrier is focused; account-wide
						High/Medium/Low stats when nothing is selected. Gated on
						CARRIER_QUALITY so the Contacts section below still renders for
						accounts without carrier quality.
					-->
					<div *ngIf="accountSettings.CARRIER_QUALITY" class="tray-section">
						<div class="tray-section-header">Quality</div>
						<app-quality
							class="full-width"
							*ngIf="
								carrierIdsToFetchNotes.length === 1 &&
								(projectDetailsStore.allProjectCarrierMapsList$ | async) as allProjectCarrierMapsList
							"
							[carrierId]="carrierIdsToFetchNotes[0]"
							[destinationCity]="projectDTO?.destCity"
							[destinationState]="projectDTO?.destState"
							[originCity]="projectDTO?.originCity"
							[originState]="projectDTO?.originState"
							[mc]="getCarrierMc(allProjectCarrierMapsList)"
							[dot]="getCarrierDot(allProjectCarrierMapsList)"
							[isCarrierInNetwork]="getIsCarrierInNetwork(allProjectCarrierMapsList)"
							[carrierActive]="true"
							[ccBookingRateDisplay]="getCarrierQuality(allProjectCarrierMapsList)?.ccBookingRateDisplay"
							[ccEngagementRateDisplay]="getCarrierQuality(allProjectCarrierMapsList)?.ccEngagementRateDisplay"
							[ccFalloffRateDisplay]="getCarrierQuality(allProjectCarrierMapsList)?.ccFalloffRateDisplay"
							[ccTotalBookedLoads]="getCarrierQuality(allProjectCarrierMapsList)?.ccTotalBookedLoads"
							[ccScore]="getCarrierQuality(allProjectCarrierMapsList)?.ccScore"
							[vettingOverallDisplay]="vettingOverallDisplay(allProjectCarrierMapsList)"
							[vettingAuthorityDisplay]="vettingAuthorityDisplay(allProjectCarrierMapsList)"
							[vettingInsuranceDisplay]="vettingInsuranceDisplay(allProjectCarrierMapsList)"
							[vettingOperationsDisplay]="vettingOperationsDisplay(allProjectCarrierMapsList)"
							[vettingSafetyDisplay]="vettingSafetyDisplay(allProjectCarrierMapsList)"
							[vettingOtherDisplay]="vettingOtherDisplay(allProjectCarrierMapsList)"
							[infractionDetails]="infractionDetails(allProjectCarrierMapsList)"
							[lastVettingTime]="getLastVettingTime(allProjectCarrierMapsList)"
						></app-quality>
						<mat-card
							*ngIf="carrierIdsToFetchNotes.length > 1"
							class="m-t-1 primary-text font-size-14"
							fxLayoutAlign="center center"
						>
							Quality score is available for a single selected carrier
						</mat-card>
						<app-quality-stats
							*ngIf="
								!carrierIdsToFetchNotes.length &&
								(tabGroup?.selectedIndex == 0 ? true : !(projectDetailsStore.loadingProjectCarrierMaps$ | async))
							"
							class="full-width"
							[capacitySearchResult]="onRecommendedTab"
							[engagedProjectCarrierMap]="onEngagedTab"
							[procuredProjectCarrierMap]="onProcuredTab"
							[capacitySearchList]="recommendedCarriersComponent?.pannelWrapperComponent?.capacitySearchResults"
							[projectCarrierMapsList]="
								onEngagedTab
									? (projectDetailsStore.engagedCarriersList$ | async)
									: procuredTabCarriersList
							"
						></app-quality-stats>
					</div>

					<!--
						Contacts section — below Quality, labeled "Contacts". Lists ALL of
						the focused carrier's contacts (same /contacts source other carrier
						views use). Each contact's phone / email are real tel:/mailto:
						anchors that ALSO open the Log-a-call dialog; the edit_note button
						opens it directly. Log-only — saving records a note + bumps Last
						Contact, it does not move the carrier between columns. Only shown
						when a single carrier is focused.
					-->
					<div *ngIf="carrierIdsToFetchNotes.length === 1" class="tray-section carrier-contacts-section">
						<div
							class="tray-section-header contacts-section-header"
							fxLayout="row"
							fxLayoutAlign="space-between center"
						>
							<span>Contacts</span>
							<!-- CN-8312: client-side filter to validated contacts only (no server call). -->
							<mat-slide-toggle
								*ngIf="trayContactList?.length"
								[(ngModel)]="showValidatedContactsOnly"
								(ngModelChange)="persistProjectFilters()"
								class="validated-only-toggle"
								color="primary"
								matTooltip="Show only validated contacts"
								>Validated only</mat-slide-toggle
							>
						</div>
						<ng-container *ngIf="trayContactList !== null; else contactsLoading">
							<div *ngIf="displayedTrayContacts.length; else noContacts">
								<div
									*ngFor="let c of displayedTrayContacts; trackBy: trackTrayContactById"
									class="carrier-contact-row"
									fxLayout="row"
									fxLayoutAlign="space-between center"
								>
									<div class="carrier-contact-info">
										<div class="carrier-contact-name">
											<mat-icon
												*ngIf="c.vettingAuthorized"
												class="contact-verification-good carrier-contact-validated"
												[matTooltip]="contactValidatedTooltip(c)"
												aria-label="Validated contact"
												>check_circle</mat-icon
											>
											<span class="carrier-contact-name-text ellipsis">{{ trayContactName(c) }}</span>
											<!--
												"Primary" = the carrier's prioritized contact for this account
												(the one emails go to). /getContacts sets prioritizedContact per
												account; primaryContact is the carrier-level flag — show the chip
												for either. Sits after the ellipsised name so a long name can't
												clip it. -->
											<span
												*ngIf="c.prioritizedContact || c.primaryContact"
												class="carrier-contact-primary"
												matTooltip="Primary contact — emails for this carrier go here."
												>Primary</span
											>
										</div>
									</div>
									<div class="carrier-contact-actions" fxLayout="row" fxLayoutAlign="end center">
										<a
											*ngIf="trayContactPhone(c)"
											mat-icon-button
											color="primary"
											[href]="'tel:' + trayContactPhone(c)"
											[matTooltip]="trayContactPhone(c)"
											aria-label="Call contact and log the call"
											(click)="logCallForFocusedCarrier(c)"
										>
											<mat-icon>phone</mat-icon>
										</a>
										<a
											*ngIf="c.emailAddress"
											mat-icon-button
											color="primary"
											[href]="'mailto:' + c.emailAddress"
											[matTooltip]="c.emailAddress"
											aria-label="Email contact and log the call"
											(click)="logCallForFocusedCarrier(c)"
										>
											<mat-icon>email</mat-icon>
										</a>
										<button
											mat-icon-button
											color="primary"
											matTooltip="Log a call"
											aria-label="Log a call"
											(click)="logCallForFocusedCarrier(c)"
										>
											<mat-icon>edit_note</mat-icon>
										</button>
									</div>
								</div>
							</div>
							<ng-template #noContacts>
								<!-- Filter on with no matches reads differently from a carrier with no contacts at all. -->
								<div
									*ngIf="showValidatedContactsOnly && trayContactList.length"
									class="carrier-contact-empty font-size-12 label-text-light"
								>
									No validated contacts.
								</div>
								<div
									*ngIf="!(showValidatedContactsOnly && trayContactList.length)"
									class="carrier-contact-empty font-size-12 label-text-light"
									fxLayout="row"
									fxLayoutAlign="space-between center"
								>
									<span>No contacts on file.</span>
									<button
										mat-icon-button
										color="primary"
										matTooltip="Log a call"
										aria-label="Log a call"
										(click)="logCallForFocusedCarrier()"
									>
										<mat-icon>edit_note</mat-icon>
									</button>
								</div>
							</ng-template>
						</ng-container>
						<ng-template #contactsLoading>
							<div class="font-size-12 label-text-light p-1">Loading contacts…</div>
						</ng-template>
					</div>
				</div>
			</app-ribbon-tray>
		</div>

		<ng-template #recommendedAndProcuredTab>
			<div
				class="hide_scrollbar_in_container overflow_y full-width"
				[ngStyle]="{
					height:
						(isAfterViewInitCompleted$ | async) &&
						pageContentContainer?.nativeElement?.offsetHeight &&
						projectDetailsAndPricingContainer?.nativeElement?.offsetHeight
							? 'calc(' +
								(pageContentContainer.nativeElement.offsetHeight -
									(projectDetailsAndPricingContainer.nativeElement.offsetHeight + 8)) +
								'px)'
							: 'height: calc(100vh - (49px + 239px + 48px + 1.5rem + 119px + 0.5rem))',
				}"
			>
				<div
					class="full-width h-100"
					fxLayout="row"
					fxLayoutAlign="top left"
					id="projectDetailsContent"
				>
					<div
						fxFlex
						style="position: relative;"
						[class.v2-bulk-select-mode]="!isWaterfallOrDedicatedLaneProject"
					>
						<!-- CN-8312 V2: tab-strip bulk-select gutter (absolutely positioned so it
						     doesn't shift the tab-group right; the tab-header gets padding-left:36px
						     in V2 to make room. Per-card gutters then sit at the same x as this. -->
						<div
							*ngIf="!isWaterfallOrDedicatedLaneProject && isCarrierTabActive()"
							class="v2-bulk-select-gutter v2-tab-strip-gutter"
						>
							<mat-checkbox
								color="primary"
								[checked]="isAllSelectedOnCurrentTab()"
								[indeterminate]="isSomeSelectedOnCurrentTab()"
								(change)="toggleSelectAllOnCurrentTab()"
								aria-label="Select all carriers on this tab"
							></mat-checkbox>
						</div>
						<mat-tab-group
							#tabGroup
							(selectedTabChange)="resetSelectedCarriers(); onTabChange()"
							class="custom-tab tab-button disable_tab_header_transition h-100"
							dynamicHeight
							[@.disabled]="true"
							[ngClass]="{
								fixed_tab_header: !isLaneDetailsProfileView,
							}"
						>
							<mat-tab [disabled]="recommendedCarriersStore.loadingLanesList$ | async">
								<ng-template matTabLabel>
									<div
										class="full-width"
										fxLayoutAlign="center center"
										dragHintClass="no-border"
										droppable
										(drop)="onRecommendedTabDrop($event)"
										[dragOverClass]="'dropHover'"
									>
										<span> Recommended </span>
										<span
											*ngIf="
												!(recommendedCarriersStore.loadingLanesList$ | async) &&
												!(projectDetailsStore.loadingProject$ | async)
											"
											[matBadge]="
												recommendedCarriersComponent?.pannelWrapperComponent?.capacitySearchResults
													.length
											"
											[ngClass]="{
												'custom-badge-w-auto':
													recommendedCarriersComponent?.pannelWrapperComponent
														?.capacitySearchResults.length >= 100,
											}"
											class="ml-6 custom-badge"
											matBadgeOverlap="false"
										>
										</span>
										<mat-spinner
											*ngIf="
												(recommendedCarriersStore.loadingLanesList$ | async) ||
												(projectDetailsStore.loadingProject$ | async)
											"
											[diameter]="11"
											class="m-b-1"
										></mat-spinner>
									</div>
								</ng-template>

								<div *ngIf="recommendedCarriersStore.loadingLanesList$ | async" class="m-t-0-5">
									<app-skeleton-loader
										cssClasses="contaier_height_auto"
										[SHOW_PANEL]="true"
										[DEFAULT_ROWS_SIZE]="4"
									>
									</app-skeleton-loader>
								</div>

								<div
									*ngIf="
										(projectDetailsStore.projectDTO$ | async) &&
										!(projectDetailsStore.loadingProjectCarrierMaps$ | async)
									"
									class="m-b-1"
									style="height: inherit"
								>
									<div
										class="full-width overflow_scroll app-default-background zIndex-20 h-100"
										[ngClass]="{
											'zIndex-10': !isLaneDetailsProfileView,
										}"
									>
										<div
											class="py-2 font-size-12 label-text-light zIndex-20 app-default-background"
											[ngClass]="{
												'zIndex-10': !isLaneDetailsProfileView,
											}"
											fxLayout="row"
											stickybits
											[stickyOffset]="0.1"
										>
											<div *ngIf="isWaterfallOrDedicatedLaneProject" fxFlex fxLayoutAlign="start center">Shift + Click to multi-select</div>
											<div fxFlex fxLayoutAlign="end center" class="text-nowrap p-r-1">
												{{
													recommendedCarriersComponent?.pannelWrapperComponent?.totalSearchLength
												}}
												Matching
												{{
													recommendedCarriersComponent?.pannelWrapperComponent?.totalSearchLength >
													1
														? 'Carriers'
														: 'Carrier'
												}}
											</div>
										</div>

										<div class="recommended_carriers_contaiener">
											<app-recommended-carriers
												style="flex: 1"
												#recommendedCarriersComponent
												(lanesCount)="NUMBER_OF_LANES = $event; populateSearchTruckForm()"
												(openLaneDetails)="openFullProfile($event, null)"
												(updateSelectedcarrierIds)="
													selectedCarrierIds = $event; populateCarrierIdsToFetchNotes()
												"
												(bulkSelectToggle)="onRecommendedBulkSelectToggle($event)"
												(panelFocused)="onRecommendedPanelFocused($event)"
												[hideLastColumn]="true"
												[showBulkSelectGutter]="!isWaterfallOrDedicatedLaneProject"
												[bulkSelectedCarrierIds]="selectedCarrierIds"
												[minLoadsPerWeek]="carrierFiltersModel.minLoadsPerWeek"
												[projectDTO]="projectDetailsStore.projectDTO$ | async"
											></app-recommended-carriers>
										</div>
									</div>
								</div>
							</mat-tab>

							<!-- Allocations Tab - Only for Workflow projects -->
							<mat-tab *ngIf="isWaterfallOrDedicatedLaneProject">
								<ng-template matTabLabel>
									<div class="full-width" fxLayoutAlign="center center">
										<span>Allocations</span>
										<span
											[matBadge]="
												(projectDetailsStore.allocatedCarriersCount$ | async) > 0
													? (projectDetailsStore.allocatedCarriersCount$ | async)
													: ''
											"
											[ngClass]="{
												'custom-badge-w-auto':
													(projectDetailsStore.allocatedCarriersCount$ | async) >= 100,
											}"
											class="ml-6 custom-badge"
											matBadgeOverlap="false"
										>
										</span>
									</div>
								</ng-template>

								<br *ngIf="projectDetailsStore.loadingProjectCarrierMaps$ | async" />

								<div
									*ngIf="
										!(projectDetailsStore.loadingProjectCarrierMaps$ | async) &&
										(projectDetailsStore.allocatedCarriersCount$ | async) === 0
									"
								>
									<mat-card class="m-t-1 m-b-1 padding-0-5" fxFlex fxLayoutAlign="center center">
										No carriers have allocations configured yet. Add allocations from the Waterfall
										tab or Recommended tab to see them here.
									</mat-card>
								</div>

								<div
									*ngIf="
										!(projectDetailsStore.loadingProjectCarrierMaps$ | async);
										else carrierMapSkeletonLoader
									"
								>
									<div
										class="full-width overflow_scroll app-default-background zIndex-20"
										[ngClass]="{
											'zIndex-10': !isLaneDetailsProfileView,
										}"
									>
										<div
											class="py-2 font-size-12 label-text-light zIndex-20 app-default-background"
											[ngClass]="{
												'zIndex-10': !isLaneDetailsProfileView,
											}"
											fxLayout="row"
											fxLayoutAlign="end center"
											stickybits
											[stickyOffset]="0.1"
										>
											Shift + Click to multi-select
										</div>

										<app-allocated-carriers
											#allocatedCarriersComponent
											(openFullProfileEvent)="
												openFullProfile($event?.projectCarrierMap, $event?.event)
											"
											(panelClicked)="onAllocatedCarrierPanelClicked($event)"
											(editAllocationEvent)="editAllocation($event?.projectCarrierMap)"
											[projectDTO]="projectDetailsStore.projectDTO$ | async"
											[accountCarrierLanes]="projectDetailsStore.accountCarrierLanes$ | async"
											[isCarrierRatesEnabled]="isCarrierRatesEnabled"
											[isLoadingAccountCarrierLanes]="
												projectDetailsStore.loadingAccountCarrierLanes$ | async
											"
											[projectCarrierMapList]="projectDetailsStore.allocatedCarriersList$ | async"
											[searchTruckForm]="searchTruckForm"
											[selectedProjectCarrierMapIDs]="selectedAllocatedCarrierMapIDs"
											[usersList]="projectDetailsStore.usersList$ | async"
									[allUsersList]="allUsersList"
											[userCarrierMapList]="recommendedCarriersStore.userCarrierMapList$ | async"
											[userCarrierMap]="recommendedCarriersStore.userCarrierMap$ | async"
											[CARRIER_QUALITY_ENABLED]="CARRIER_QUALITY_ENABLED"
											[carrierAllocationsMap]="projectDetailsStore.carrierAllocationsMap$ | async"
										></app-allocated-carriers>
									</div>
								</div>
							</mat-tab>

							<mat-tab
								*ngIf="
									environment.ENABLE_ENGAGED_TAB_ON_PROJECT_DETAILS &&
									!isWaterfallOrDedicatedLaneProject
								"
							>
								<ng-template matTabLabel>
									<div
										class="full-width"
										fxLayoutAlign="center center"
										dragHintClass="no-border"
										droppable
										(drop)="onEngagedTabDrop($event)"
										[dragOverClass]="'dropHover'"
									>
										<span> Engaged </span>
										<span
											[matBadge]="
												(projectDetailsStore.engagedCarriersCount$ | async) > 0
													? (projectDetailsStore.engagedCarriersCount$ | async)
													: ''
											"
											[ngClass]="{
												'custom-badge-w-auto':
													(projectDetailsStore.engagedCarriersCount$ | async) >= 100,
											}"
											class="ml-6 custom-badge"
											matBadgeOverlap="false"
										>
										</span>
									</div>
								</ng-template>

								<br *ngIf="projectDetailsStore.loadingProjectCarrierMaps$ | async" />

								<div
									*ngIf="
										!(projectDetailsStore.loadingProjectCarrierMaps$ | async) &&
										(projectDetailsStore.engagedCarriersList$ | async).length === 0
									"
								>
									<mat-card class="m-t-1 m-b-1 padding-0-5" fxFlex fxLayoutAlign="center center">
										No carriers are engaged. You can start by clicking on the Recommended tab and
										looking at the list of matches we have identified.
									</mat-card>
								</div>

								<div
									*ngIf="
										!(projectDetailsStore.loadingProjectCarrierMaps$ | async);
										else carrierMapSkeletonLoader
									"
								>
									<div
										class="full-width overflow_scroll app-default-background zIndex-20"
										[ngClass]="{
											'zIndex-10': !isLaneDetailsProfileView,
										}"
									>
										<div
											class="py-2 font-size-12 label-text-light zIndex-20 app-default-background"
											[ngClass]="{
												'zIndex-10': !isLaneDetailsProfileView,
											}"
											fxLayout="row"
											stickybits
											[stickyOffset]="0.1"
										>
											<div *ngIf="isWaterfallOrDedicatedLaneProject" fxFlex fxLayoutAlign="start center">
												Shift + Click to multi-select
											</div>
											<div fxFlex fxLayoutAlign="end center" class="text-nowrap p-r-1">
												{{ (projectDetailsStore.engagedCarriersCount$ | async) || 0 }}
												Engaged
												{{
													((projectDetailsStore.engagedCarriersCount$ | async) || 0) > 1
														? 'Carriers'
														: 'Carrier'
												}}
											</div>
										</div>

										<app-procured-carriers
											#engagedCarriersComponent
											[enableOnboardCarrier]="true"
											(fireSegmentEvent)="
												fireSegmentEvent($event?.projectId, $event?.carrierId, $event?.cIndex)
											"
											(openFullProfileEvent)="
												openFullProfile($event?.projectCarrierMap, $event?.event)
											"
											(panelClicked)="panelClicked($event)"
											(bulkSelectToggle)="onBulkSelectToggle($event)"
											[hideLastColumn]="true"
											[showBulkSelectGutter]="!isWaterfallOrDedicatedLaneProject"
											[projectDTO]="projectDetailsStore.projectDTO$ | async"
											[accountCarrierLanes]="projectDetailsStore.accountCarrierLanes$ | async"
											[isCarrierRatesEnabled]="isCarrierRatesEnabled"
											[isLoadingAccountCarrierLanes]="
												projectDetailsStore.loadingAccountCarrierLanes$ | async
											"
											[projectCarrierMapList]="engagedCarriersSorted$ | async"
											[searchTruckForm]="searchTruckForm"
											[selectedProjectCarrierMapIDs]="selectedProjectCarrierMapIDs"
											[usersList]="projectDetailsStore.usersList$ | async"
									[allUsersList]="allUsersList"
											[userCarrierMapList]="recommendedCarriersStore.userCarrierMapList$ | async"
											[userCarrierMap]="recommendedCarriersStore.userCarrierMap$ | async"
											[isCarrierVettingIntegrationEnabled]="isCarrierVettingIntegrationEnabled"
											[CARRIER_QUALITY_ENABLED]="CARRIER_QUALITY_ENABLED"
										></app-procured-carriers>
									</div>
								</div>
							</mat-tab>

							<mat-tab>
								<ng-template matTabLabel>
									<div
										class="full-width"
										fxLayoutAlign="center center"
										dragHintClass="no-border"
										droppable
										(drop)="onProcuredTabDrop($event)"
										[dragOverClass]="'dropHover'"
									>
										<span>{{ isWaterfallOrDedicatedLaneProject ? 'Waterfall' : 'Procured' }}</span>
										<span
											[matBadge]="
												(projectDetailsStore.procuredCarriersCount$ | async) > 0
													? (projectDetailsStore.procuredCarriersCount$ | async)
													: ''
											"
											[ngClass]="{
												'custom-badge-w-auto':
													(projectDetailsStore.procuredCarriersCount$ | async) >= 100,
											}"
											class="ml-6 custom-badge"
											matBadgeOverlap="false"
										>
										</span>
									</div>
								</ng-template>

								<br *ngIf="projectDetailsStore.loadingProjectCarrierMaps$ | async" />
								<div
									*ngIf="
										(projectDetailsStore.procuredCarriersCount$ | async) === 0 &&
										(projectDetailsStore.procuredCarriersWithoutGroupCount$ | async) === 0 &&
										!(projectDetailsStore.loadingProjectCarrierMaps$ | async)
									"
								>
									<mat-card class="m-t-1 m-b-1 padding-0-5" fxFlex fxLayoutAlign="center center">
										<ng-container
											*ngIf="isWaterfallOrDedicatedLaneProject; else procuredEmptyMessage"
										>
											No carriers have been added to the waterfall. You can start by clicking on the
											Recommended tab and adding carriers to the waterfall.
										</ng-container>
										<ng-template #procuredEmptyMessage>
											No carriers have been added to this project. You can start by clicking on the
											Recommended tab and looking at the list of matches we have identified.
										</ng-template>
									</mat-card>
								</div>

								<div
									*ngIf="
										!(projectDetailsStore.loadingProjectCarrierMaps$ | async);
										else carrierMapSkeletonLoader
									"
								>
									<div
										class="full-width overflow_scroll app-default-background zIndex-20"
										[ngClass]="{
											'zIndex-10': !isLaneDetailsProfileView,
										}"
									>
										<div
											class="py-2 font-size-12 label-text-light zIndex-20 app-default-background"
											[ngClass]="{
												'zIndex-10': !isLaneDetailsProfileView,
											}"
											fxLayout="row"
											stickybits
											[stickyOffset]="0"
										>
											<div *ngIf="isWaterfallOrDedicatedLaneProject" fxFlex fxLayoutAlign="start center">
												Shift + Click to multi-select
											</div>
											<div fxFlex fxLayoutAlign="end center" class="text-nowrap p-r-1">
												{{ (projectDetailsStore.procuredCarriersCount$ | async) || 0 }}
												Procured
												{{
													((projectDetailsStore.procuredCarriersCount$ | async) || 0) > 1
														? 'Carriers'
														: 'Carrier'
												}}
											</div>
										</div>

										<div *ngIf="projectId">
											<app-project-groups
												#projectGroups
												(procuredCarriersSelectionUpdated)="procuredCarriersSelectionUpdated()"
												(openFullProfileEvent)="
													openFullProfile($event?.projectCarrierMap, $event?.event)
												"
												(editAllocationEvent)="editAllocation($event?.projectCarrierMap)"
												[isWorkflowProject]="isWaterfallOrDedicatedLaneProject"
												[carrierAllocationsMap]="projectDetailsStore.carrierAllocationsMap$ | async"
											>
											</app-project-groups>
										</div>

										<app-procured-carriers
											#procuredCarriersComponent
											(fireSegmentEvent)="
												fireSegmentEvent($event?.projectId, $event?.carrierId, $event?.cIndex)
											"
											(openFullProfileEvent)="
												openFullProfile($event?.projectCarrierMap, $event?.event)
											"
											(panelClicked)="panelClicked($event)"
											(editAllocationEvent)="editAllocation($event?.projectCarrierMap)"
											(bulkSelectToggle)="onBulkSelectToggle($event)"
											[hideLastColumn]="true"
											[showBulkSelectGutter]="!isWaterfallOrDedicatedLaneProject"
											[accountCarrierLanes]="projectDetailsStore.accountCarrierLanes$ | async"
											[isCarrierRatesEnabled]="isCarrierRatesEnabled"
											[isLoadingAccountCarrierLanes]="
												projectDetailsStore.loadingAccountCarrierLanes$ | async
											"
											[projectCarrierMapList]="(isWaterfallOrDedicatedLaneProject ? projectDetailsStore.procuredCarriersList$ : procuredCarriersSorted$) | async"
											[projectDTO]="projectDetailsStore.projectDTO$ | async"
											[searchTruckForm]="searchTruckForm"
											[selectedProjectCarrierMapIDs]="selectedProjectCarrierMapIDs"
											[usersList]="projectDetailsStore.usersList$ | async"
									[allUsersList]="allUsersList"
											[userCarrierMapList]="recommendedCarriersStore.userCarrierMapList$ | async"
											[userCarrierMap]="recommendedCarriersStore.userCarrierMap$ | async"
											[isCarrierVettingIntegrationEnabled]="isCarrierVettingIntegrationEnabled"
											[CARRIER_QUALITY_ENABLED]="CARRIER_QUALITY_ENABLED"
											[isWorkflowProject]="isWaterfallOrDedicatedLaneProject"
											[carrierAllocationsMap]="projectDetailsStore.carrierAllocationsMap$ | async"
										></app-procured-carriers>
									</div>
								</div>
							</mat-tab>

							<mat-tab disabled>
								<ng-template class="full-width" matTabLabel>
									<div fxFlex fxLayoutAlign="end center" fxLayoutGap="0.5rem">
										<button
											mat-raised-button
											color="primary"
											[mtxPopoverTriggerFor]="capacitySearchFiltersPopover"
											mtxPopoverTriggerOn="click"
											#popoverTrigger="mtxPopoverTrigger"
										>
											FILTER<span>{{ filterIndicator }}</span>
											<mat-icon>expand_more</mat-icon>
										</button>

										<button
											*ngIf="tabGroup.selectedIndex === 0"
											mat-raised-button
											color="primary"
											[mtxPopoverTriggerFor]="capacitySearchSortPopover"
											mtxPopoverTriggerOn="click"
											#popoverTrigger="mtxPopoverTrigger"
										>
											SORT
											{{
												carrierFiltersModel.capacitySearchSort === 'match'
													? '(BEST Match)'
													: carrierFiltersModel.capacitySearchSort === 'quality'
														? '(Quality)'
														: '(Frequency)'
											}}
											<mat-icon>expand_more</mat-icon>
										</button>

										<!-- CN-8312 V2: client-side sort for Engaged + Procured tabs. Hidden on a
										     Workflow project's Waterfall tab, where the list below the group cards
										     is only the ungrouped tail — sorting it would leave the priority
										     groups above untouched. -->
										<button
											*ngIf="
												onEngagedTab ||
												(onProcuredTab && !isWaterfallOrDedicatedLaneProject)
											"
											mat-raised-button
											color="primary"
											[mtxPopoverTriggerFor]="engagedProcuredSortPopover"
											mtxPopoverTriggerOn="click"
										>
											SORT
											{{
												engagedProcuredSort === 'match'
													? '(BEST Match)'
													: engagedProcuredSort === 'quality'
														? '(Quality)'
														: engagedProcuredSort === 'frequency'
															? '(Frequency)'
															: engagedProcuredSort === 'lastContact'
																? '(Last Contacted)'
																: '(Has Rate)'
											}}
											<mat-icon>expand_more</mat-icon>
										</button>

										<button
											mat-raised-button
											color="primary"
											[matMenuTriggerFor]="recommendedTabActions"
											(menuOpened)="updateRecommendedTabActionsPanelClass()"
										>
											ACTIONS
											<mat-icon>expand_more</mat-icon>
										</button>
										<mat-menu
											fxFlex
											#recommendedTabActions="matMenu"
											class="cc_menu_container"
										>
											<!-- Hide these options on Allocations tab -->
											<ng-container *ngIf="!onAllocationsTab">
												<button
													(click)="addCarrierContact()"
													color="primary"
													mat-menu-item
													*ngIf="
														!utilService.isNullOrUndefined(tabGroup) &&
														showProcuredTabOptions(tabGroup.selectedIndex) &&
														(projectDetailsStore.projectGroups$ | async)?.length
															? !moreThanOneProjectCarrierMapSelected(
																	(projectDetailsStore.projectGroups$ | async)?.length
																)
															: selectedProjectCarrierMapIDs.length == 1
													"
												>
													Add Contact
												</button>

												<app-request-for-proposal
													(updatedData)="rfpCompleted($event)"
													*ngIf="
														!utilService.isNullOrUndefined(tabGroup) &&
														(onEngagedTab ||
															showProcuredTabOptions(tabGroup.selectedIndex))
													"
													[buttonText]="'Check Capacity'"
													[isOnRecommendedTab]="false"
													[numberOfCarriers]="
														onEngagedTab
															? (projectDetailsStore.engagedCarriersCount$ | async)
															: (projectDetailsStore.procuredCarriersCount$ | async)
													"
													[carrierMapIds]="
														projectCarrierMapIds(
															onEngagedTab
																? (projectDetailsStore.engagedCarriersList$ | async)
																: (projectDetailsStore.procuredCarriersList$ | async)
														)
													"
													[projectDTO]="projectDetailsStore.projectDTO$ | async"
													[useMenuButton]="true"
												></app-request-for-proposal>

												<button
													*ngIf="isWaterfallOrDedicatedLaneProject"
													(click)="openBADialog()"
													color="primary"
													[disabled]="!bookingAssistantService.isBookingAssistantEnabled()"
													mat-menu-item
												>
													Booking Assistant
												</button>
											</ng-container>

											<!-- Allocation buttons for Allocations/Waterfall tabs -->
											<!-- Note: Using tabGroup.selectedIndex !== 0 instead of showProcuredTabOptions
											     because ENABLE_ENGAGED_TAB_ON_PROJECT_DETAILS flag may not match actual tab layout -->
											<ng-container
												*ngIf="
													IS_NOT_NULL_OR_UNDEFINED(tabGroup) &&
													tabGroup.selectedIndex !== 0 &&
													isWaterfallOrDedicatedLaneProject
												"
											>
												<!-- Add Allocation (when carrier has no allocation) -->
												<button
													*ngIf="!(selectedCarrierHasAllocation$ | async)"
													(click)="editSelectedCarrierAllocation()"
													color="primary"
													mat-menu-item
													[disabled]="
														selectedAllocatedCarrierMapIDs.length === 1
															? false
															: (projectDetailsStore.projectGroups$ | async)?.length
																? moreThanOneProjectCarrierMapSelected(
																		(projectDetailsStore.projectGroups$ | async)?.length
																	)
																: selectedProjectCarrierMapIDs.length !== 1
													"
												>
													Add Allocation
												</button>
												<!-- Edit Allocation (when carrier has allocation) -->
												<button
													*ngIf="selectedCarrierHasAllocation$ | async"
													(click)="editSelectedCarrierAllocation()"
													color="primary"
													mat-menu-item
													[disabled]="
														selectedAllocatedCarrierMapIDs.length === 1
															? false
															: (projectDetailsStore.projectGroups$ | async)?.length
																? moreThanOneProjectCarrierMapSelected(
																		(projectDetailsStore.projectGroups$ | async)?.length
																	)
																: selectedProjectCarrierMapIDs.length !== 1
													"
												>
													Edit Allocation
												</button>
												<!-- Remove Allocation (when carrier has allocation) -->
												<button
													*ngIf="selectedCarrierHasAllocation$ | async"
													(click)="removeSelectedCarrierAllocation()"
													color="primary"
													mat-menu-item
													[disabled]="
														selectedAllocatedCarrierMapIDs.length === 1
															? false
															: (projectDetailsStore.projectGroups$ | async)?.length
																? moreThanOneProjectCarrierMapSelected(
																		(projectDetailsStore.projectGroups$ | async)?.length
																	)
																: selectedProjectCarrierMapIDs.length !== 1
													"
												>
													Remove Allocation
												</button>
											</ng-container>

											<button
												(click)="onAllowBookNowClick()"
												color="primary"
												*ngIf="
													!utilService.isNullOrUndefined(tabGroup) &&
													showProcuredTabOptions(tabGroup.selectedIndex) &&
													!onAllocationsTab && isWaterfallOrDedicatedLaneProject
												"
												mat-menu-item
											>
												Allow Book Now
											</button>

											<ng-container *ngIf="tabGroup.selectedIndex == 0">
												<!-- Engage is only for Procurement projects, not Workflows -->
												<button
													(click)="engageWithCarriers()"
													color="primary"
													mat-menu-item
													[disabled]="!selectedCarrierIds.length"
													*ngIf="
														environment.ENABLE_ENGAGED_TAB_ON_PROJECT_DETAILS &&
														!isWaterfallOrDedicatedLaneProject
													"
												>
													Engage
												</button>
												<button
													(click)="moveRecommendedToProcured()"
													color="primary"
													mat-menu-item
													[disabled]="!selectedCarrierIds.length"
												>
													{{ isWaterfallOrDedicatedLaneProject ? 'Add to Waterfall' : 'Procure' }}
												</button>
												<!-- Add Allocation on Recommended tab (for workflow projects) -->
												<button
													*ngIf="isWaterfallOrDedicatedLaneProject"
													(click)="editSelectedCarrierAllocation()"
													color="primary"
													mat-menu-item
													[disabled]="selectedCarrierIds.length !== 1"
												>
													Add Allocation
												</button>
												<button *ngIf="isWaterfallOrDedicatedLaneProject" (click)="selectAllCarriers()" color="primary" mat-menu-item>
													Select All Carriers
												</button>
												<button
													(click)="downloadCapacitySearchResultsCsv()"
													color="primary"
													mat-menu-item
												>
													Export
												</button>
												<button
													(click)="utilService.navigateToCapacitySearch(projectDTO)"
													color="primary"
													mat-menu-item
													[disabled]="!(recommendedCarriersStore.hasLane$ | async)"
												>
													Search Capacity
												</button>
											</ng-container>

											<!-- Engaged tab actions (only for non-workflow projects at index 1) -->
											<ng-container *ngIf="tabGroup.selectedIndex == 1 && !onAllocationsTab">
												<button
													(click)="moveEngagedToProcured()"
													color="primary"
													mat-menu-item
													[disabled]="!selectedProjectCarrierMapIDs.length"
													*ngIf="environment.ENABLE_ENGAGED_TAB_ON_PROJECT_DETAILS"
												>
													{{ isWaterfallOrDedicatedLaneProject ? 'Add to Waterfall' : 'Procure' }}
												</button>
												<button
													(click)="removeEngagedCarriers()"
													color="primary"
													mat-menu-item
													[disabled]="!selectedProjectCarrierMapIDs.length"
													*ngIf="environment.ENABLE_ENGAGED_TAB_ON_PROJECT_DETAILS"
												>
													Remove
												</button>
												<button
													(click)="bulkOnboardEngagedCarriers()"
													color="primary"
													mat-menu-item
													[disabled]="!selectedProjectCarrierMapIDs.length"
													*ngIf="
														environment.ENABLE_ENGAGED_TAB_ON_PROJECT_DETAILS &&
														canBulkOnboardEngaged
													"
												>
													Onboard Carriers
												</button>
												<button
													(click)="exportEngagedCarriers()"
													[disabled]="!(projectDetailsStore.engagedCarriersCount$ | async)"
													color="primary"
													mat-menu-item
												>
													Export
												</button>
											</ng-container>

											<!-- Update Rate for non-Allocations tabs -->
											<ng-container
												*ngIf="
													IS_NOT_NULL_OR_UNDEFINED(tabGroup) &&
													tabGroup.selectedIndex &&
													!onAllocationsTab
												"
											>
												<button
													(click)="addDesiredRate()"
													color="primary"
													mat-menu-item
													[disabled]="
														(projectDetailsStore.projectGroups$ | async)?.length
															? moreThanOneProjectCarrierMapSelected(
																	(projectDetailsStore.projectGroups$ | async)?.length
																)
															: selectedProjectCarrierMapIDs.length !== 1
													"
												>
													Update Rate
												</button>
											</ng-container>

											<!-- Allocations tab specific actions: Update Rate and Export -->
											<ng-container *ngIf="onAllocationsTab">
												<button
													(click)="addDesiredRate()"
													color="primary"
													mat-menu-item
													[disabled]="selectedAllocatedCarrierMapIDs.length !== 1"
												>
													Update Rate
												</button>
												<button
													(click)="exportAllocatedCarriers()"
													color="primary"
													mat-menu-item
													[disabled]="!(projectDetailsStore.allocatedCarriersCount$ | async)"
												>
													Export
												</button>
											</ng-container>

											<ng-container
												*ngIf="
													IS_NOT_NULL_OR_UNDEFINED(tabGroup) &&
													tabGroup.selectedIndex &&
													!onAllocationsTab && {
														projectGroupsLength: projectDetailsStore.projectGroups$ | async,
													} as store
												"
											>
												<button
													(click)="reportDataAction('lane')"
													color="primary"
													mat-menu-item
													[disabled]="
														!!moreThanOneProjectCarrierMapSelected(
															store.projectGroupsLength?.length
														)
													"
												>
													Report Incorrect Lane
												</button>
												<button
													(click)="reportDataAction('contact')"
													color="primary"
													mat-menu-item
													[disabled]="
														!!moreThanOneProjectCarrierMapSelected(
															store.projectGroupsLength?.length
														)
													"
												>
													Report Incorrect Contact
												</button>
											</ng-container>

											<!-- Group actions for Waterfall/Procured tab (hidden on Allocations tab) -->
											<!-- Note: Using tabGroup.selectedIndex !== 0 instead of showProcuredTabOptions
											     because ENABLE_ENGAGED_TAB_ON_PROJECT_DETAILS flag may not match actual tab layout -->
											<ng-container *ngIf="tabGroup.selectedIndex !== 0 && !onAllocationsTab">
												<button
													*ngIf="
														environment.FEATURE_FLAGS.PROCURED_CARRIERS_EMAIL &&
														isWaterfallOrDedicatedLaneProject
													"
													(click)="sendProcuredCarriersEmail()"
													color="primary"
													mat-menu-item
												>
													Send Project Setup Email
												</button>

												<!-- Group management actions — Workflow-only (Waterfall / Dedicated
												     Lane). Procurement projects don't use carrier groups so these
												     items are hidden in V1, V2, and V3 for non-workflow projects. -->
												<ng-container *ngIf="isWaterfallOrDedicatedLaneProject">
													<button
														(click)="createProjectGroup()"
														color="primary"
														mat-menu-item
														[disabled]="
															!selectedProjectCarrierMapIDs.length &&
															!projectGroupsComponent?.ungroupedSelectedProjectCarrierMapIds.length &&
															!projectGroupsComponent?.createGroupFromUserGroupEnabled
														"
													>
														Create Group
													</button>
													<button
														(click)="editProjectGroup()"
														color="primary"
														mat-menu-item
														[disabled]="
															!(projectDetailsStore.projectGroups$ | async)?.length ||
															projectGroupsComponent?.systemGroupSelected ||
															projectGroupsComponent?.selectedProjectGroupIds.length !== 1
														"
													>
														Edit Group
													</button>
													<button
														(click)="addCarriersToGroup()"
														color="primary"
														mat-menu-item
														[disabled]="
															!(projectDetailsStore.projectGroups$ | async)?.length ||
															!projectGroupsComponent?.selectedProjectCarrierMapIds.length
														"
													>
														Move to Group
													</button>
													<button
														(click)="mergeGroups()"
														color="primary"
														mat-menu-item
														[disabled]="
															!(projectDetailsStore.projectGroups$ | async)?.length ||
															projectGroupsComponent?.systemGroupSelected ||
															projectGroupsComponent?.selectedProjectGroupIds.length < 2
														"
													>
														Merge Groups
													</button>
													<button
														(click)="moveProjectGroups('up')"
														color="primary"
														mat-menu-item
														[disabled]="
															!projectGroupsComponent?.selectedProjectGroupIds.length ||
															projectGroupsComponent.highestPriorityGroupSelected ||
															projectGroupsComponent?.systemGroupSelected
														"
													>
														Move Up
													</button>
													<button
														(click)="moveProjectGroups('down')"
														color="primary"
														mat-menu-item
														[disabled]="
															!projectGroupsComponent?.selectedProjectGroupIds.length ||
															projectGroupsComponent.lowestPriorityGroupSelected ||
															projectGroupsComponent?.systemGroupSelected
														"
													>
														Move Down
													</button>
												</ng-container>
												<button
													(click)="exportProcuredCarriers()"
													[disabled]="!(projectDetailsStore.procuredCarriersCount$ | async)"
													color="primary"
													mat-menu-item
												>
													Export
												</button>
												<button
													*ngIf="isWaterfallOrDedicatedLaneProject"
													(click)="removeFormGroup()"
													color="primary"
													mat-menu-item
													[disabled]="
														!projectGroupsComponent?.selectedProjectCarrierMapIds.length ||
														projectGroupsComponent?.systemGroupSelected
													"
												>
													Remove From Group
												</button>
												<button
													*ngIf="onProcuredTab"
													(click)="removeProcuredCarriers()"
													color="primary"
													mat-menu-item
													[disabled]="
														!selectedProjectCarrierMapIDs.length &&
														!projectGroupsComponent?.selectedProjectCarrierMapIds.length
													"
												>
													Remove From Procured
												</button>
												<button
													*ngIf="isWaterfallOrDedicatedLaneProject"
													(click)="deleteGroups()"
													color="primary"
													mat-menu-item
													[disabled]="
														!projectGroupsComponent?.selectedProjectGroupIds?.length ||
														projectGroupsComponent?.systemGroupSelected ||
														(projectDetailsStore.projectGroups$ | async)?.length <= 1 ||
														(projectDetailsStore.projectGroups$ | async)?.length ==
															projectGroupsComponent?.selectedProjectGroupIds?.length
													"
												>
													Delete Group
												</button>
											</ng-container>
										</mat-menu>
									</div>
								</ng-template>
							</mat-tab>
						</mat-tab-group>
					</div>
				</div>
			</div>
		</ng-template>
	</div>

	<mtx-popover #capacitySearchFiltersPopover="mtxPopover" [closeOnPanelClick]="false">
		<mat-card class="p-0 primary-border" *ngIf="carrierFiltersModel">
			<mat-card-content class="filter_dropdown font-size-14 padding-0-5">
				<div class="m-t-0-5" fxLayout="row">
					<div
						fxFlex
						fxLayout="row"
						fxLayoutAlign="start end"
						class="font-weight-bold primary-text"
						[ngClass]="{ 'disable-text': tabGroup?.selectedIndex !== 0 || customerOnly }"
					>
						Origin Deadhead
					</div>
					<div fxFlex fxLayout="row" fxLayoutAlign="end center">
						<mat-icon
							class="primary-text cursor-pointer"
							(click)="tabGroup?.selectedIndex !== 0 ? null : setOriginDeadhead(-5)"
							[ngClass]="{
								'disable-text cursor_not_allowed': tabGroup?.selectedIndex !== 0 || customerOnly,
							}"
						>
							remove
						</mat-icon>
						<mat-form-field
							floatLabel="never"
							class="number_formfield_filter_container custom-form-field"
						>
							<input
								(keyup.enter)="
									onDeadheadChange(
										CARGOCHIEF_KEYS.ORIGIN_DEADHEAD_SLIDER,
										carrierFiltersModel.originDeadhead
									)
								"
								[(ngModel)]="carrierFiltersModel.originDeadhead"
								autocomplete="off"
								matInput
								type="number"
								class="input_number_field"
								[disabled]="tabGroup?.selectedIndex !== 0 || customerOnly"
							/>
						</mat-form-field>
						<mat-icon
							class="primary-text cursor-pointer"
							(click)="tabGroup?.selectedIndex !== 0 ? null : setOriginDeadhead(5)"
							[ngClass]="{
								'disable-text cursor_not_allowed': tabGroup?.selectedIndex !== 0 || customerOnly,
							}"
						>
							add
						</mat-icon>
					</div>
				</div>
				<div class="m-t-0-5" fxLayout="row">
					<div
						fxFlex
						fxLayout="row"
						fxLayoutAlign="start end"
						class="font-weight-bold primary-text"
						[ngClass]="{ 'disable-text': tabGroup?.selectedIndex !== 0 || customerOnly }"
					>
						Destination Deadhead
					</div>
					<div fxFlex fxLayout="row" fxLayoutAlign="end center">
						<mat-icon
							class="primary-text cursor-pointer"
							(click)="tabGroup?.selectedIndex !== 0 ? null : setDestinatioDeadhead(-5)"
							[ngClass]="{
								'disable-text cursor_not_allowed': tabGroup?.selectedIndex !== 0 || customerOnly,
							}"
						>
							remove
						</mat-icon>
						<mat-form-field
							floatLabel="never"
							class="number_formfield_filter_container custom-form-field"
						>
							<input
								(keyup.enter)="
									onDeadheadChange(
										CARGOCHIEF_KEYS.DESTINATION_DEADHEAD_SLIDER,
										carrierFiltersModel.destinationDeadhead
									)
								"
								[(ngModel)]="carrierFiltersModel.destinationDeadhead"
								autocomplete="off"
								matInput
								type="number"
								class="input_number_field"
								[disabled]="tabGroup?.selectedIndex !== 0 || customerOnly"
							/>
						</mat-form-field>
						<mat-icon
							class="primary-text cursor-pointer"
							(click)="tabGroup?.selectedIndex !== 0 ? null : setDestinatioDeadhead(5)"
							[ngClass]="{
								'disable-text cursor_not_allowed': tabGroup?.selectedIndex !== 0 || customerOnly,
							}"
						>
							add
						</mat-icon>
					</div>
				</div>
				<div class="m-t-0-5" fxLayout="row">
					<div
						fxFlex
						fxLayout="row"
						fxLayoutAlign="start end"
						class="font-weight-bold primary-text"
						[ngClass]="{ 'disable-text': customerOnly }"
					>
						Min Truck Count
					</div>
					<div fxFlex fxLayout="row" fxLayoutAlign="end center">
						<mat-icon
							class="primary-text cursor-pointer"
							(click)="setPowerUnits(-1)"
							[ngClass]="{ 'disable-text cursor_not_allowed': customerOnly }"
							>remove</mat-icon
						>
						<mat-form-field
							floatLabel="never"
							class="number_formfield_filter_container custom-form-field"
						>
							<input
								[(ngModel)]="carrierFiltersModel.powerUnits"
								autocomplete="off"
								matInput
								type="number"
								class="input_number_field"
								min="0"
								[disabled]="customerOnly"
							/>
						</mat-form-field>
						<mat-icon
							class="primary-text cursor-pointer"
							(click)="setPowerUnits(1)"
							[ngClass]="{ 'disable-text cursor_not_allowed': customerOnly }"
							>add</mat-icon
						>
					</div>
				</div>
				<div class="m-t-0-5" fxLayout="row">
					<div
						fxFlex
						fxLayout="row"
						fxLayoutAlign="start end"
						class="font-weight-bold primary-text"
						[ngClass]="{ 'disable-text': tabGroup?.selectedIndex !== 0 || customerOnly }"
					>
						Min Frequency
					</div>
					<div fxFlex fxLayout="row" fxLayoutAlign="end center">
						<mat-icon
							class="primary-text cursor-pointer"
							(click)="tabGroup?.selectedIndex !== 0 ? null : setMinLoadsPerWeek(-1)"
							[ngClass]="{
								'disable-text cursor_not_allowed': tabGroup?.selectedIndex !== 0 || customerOnly,
							}"
						>
							remove
						</mat-icon>
						<mat-form-field
							floatLabel="never"
							class="number_formfield_filter_container custom-form-field"
						>
							<input
								[(ngModel)]="carrierFiltersModel.minLoadsPerWeek"
								autocomplete="off"
								matInput
								type="number"
								class="input_number_field"
								[disabled]="tabGroup?.selectedIndex !== 0 || customerOnly"
							/>
						</mat-form-field>
						<mat-icon
							class="primary-text cursor-pointer"
							(click)="tabGroup?.selectedIndex !== 0 ? null : setMinLoadsPerWeek(1)"
							[ngClass]="{
								'disable-text cursor_not_allowed': tabGroup?.selectedIndex !== 0 || customerOnly,
							}"
						>
							add
						</mat-icon>
					</div>
				</div>

				<div class="m-t-0-5" fxLayout="row">
					<div
						fxFlex
						fxLayout="row"
						fxLayoutAlign="start end"
						class="font-weight-bold primary-text"
					>
						Quality
					</div>
					<div fxFlex fxLayout="row" fxLayoutAlign="end center">
						<mat-form-field floatLabel="never" class="custom-form-field full-width">
							<mat-select [(ngModel)]="carrierFiltersModel.qualityFilter">
								<mat-option *ngFor="let option of qualityFilterOptions" [value]="option.value">
									{{ option.label }}
								</mat-option>
							</mat-select>
						</mat-form-field>
					</div>
				</div>

				<div class="m-t-1" fxLayout="row">
					<div
						fxFlex
						fxLayout="row"
						fxLayoutAlign="start end"
						class="font-weight-bold primary-text"
						[ngClass]="{ 'disable-text': tabGroup?.selectedIndex === 0 }"
					>
						Has Rate
					</div>
					<div fxFlex fxLayout="row" fxLayoutAlign="end center">
						<mat-checkbox
							[(ngModel)]="carrierFiltersModel.ratesOnly"
							[color]="'primary'"
							[labelPosition]="'after'"
							class="fs-13"
							[disabled]="tabGroup?.selectedIndex === 0"
						>
						</mat-checkbox>
					</div>
				</div>
				<div class="m-t-0-5" fxLayout="row">
					<div
						fxFlex
						fxLayout="row"
						fxLayoutAlign="start end"
						class="font-weight-bold primary-text"
					>
						MC/DOT
					</div>
					<div fxFlex>
						<mat-form-field floatLabel="never" class="custom-form-field">
							<mat-label>Search</mat-label>
							<input
								[(ngModel)]="carrierFiltersModel.carriersSearchText"
								autocomplete="off"
								matInput
							/>
							<mat-icon
								[matTooltip]="tooltipMessage"
								class="primary-light-color info-icon cursor-pointer"
								content-type="template"
								matSuffix
							>
								info
							</mat-icon>
						</mat-form-field>
					</div>
				</div>

				<div class="m-t-0-5" fxLayout="row">
					<mat-form-field fxFlex class="custom-form-field" floatLabel="never">
						<mat-label>Carrier HQ</mat-label>
						<mat-select
							[(ngModel)]="carrierFiltersModel.carrierHQ"
							[disabled]="tabGroup?.selectedIndex !== 0"
						>
							<mat-option *ngFor="let option of carrierHQOptions" [value]="option">
								{{ option }}
							</mat-option>
						</mat-select>
					</mat-form-field>
					<mat-icon
						(click)="removeHQFilter()"
						*ngIf="carrierFiltersModel.carrierHQ.length > 1"
						class="danger-text cursor-pointer"
						>close
					</mat-icon>
				</div>
				<div class="m-t-0-5" fxLayout="row">
					<mat-form-field fxFlex class="custom-form-field">
						<mat-select [(ngModel)]="carrierFiltersModel.carrierSelected">
							<mat-option *ngFor="let option of carriersFilterOptions" [value]="option">
								{{ option }}
							</mat-option>
						</mat-select>
					</mat-form-field>
				</div>
			</mat-card-content>
			<mat-divider></mat-divider>
			<mat-card-actions>
				<div
					fxLayout="row"
					fxLayoutAlign="end center"
					class="p-1 p-t-0"
					fxLayoutGap="1rem"
					*ngIf="recommendedCarriersStore.filters$ | async as storeFilters"
				>
					<button
						mat-button
						type="button"
						(click)="clearFilters()"
						[disabled]="!filterIndicator"
						[ngClass]="filterIndicator ? 'link-primary' : 'disable-text'"
						class="font-size-14"
					>
						Clear filters
					</button>
					<button
						mat-raised-button
						color="primary"
						(click)="applyFilter()"
						[disabled]="isFilterChange(storeFilters)"
					>
						Apply
					</button>
				</div>
			</mat-card-actions>
		</mat-card>
	</mtx-popover>

	<mtx-popover #capacitySearchSortPopover="mtxPopover" [closeOnPanelClick]="false">
		<mat-card class="p-0 primary-border" *ngIf="carrierFiltersModel">
			<mat-card-content class="filter_dropdown font-size-14 padding-0-5">
				<div class="m-t-0-5" fxLayout="row">
					<mat-button-toggle-group
						fxFlex
						[(ngModel)]="carrierFiltersModel.capacitySearchSort"
						(change)="sortRecommendedCarriers()"
					>
						<mat-button-toggle [value]="RANGE_FILTERS.SORT.MATCH" fxFlex>
							Best Match
						</mat-button-toggle>
						<mat-button-toggle fxFlex [value]="RANGE_FILTERS.SORT.FREQUENCY">
							Frequency
						</mat-button-toggle>
						<mat-button-toggle fxFlex [value]="RANGE_FILTERS.SORT.QUALITY">
							Quality
						</mat-button-toggle>
					</mat-button-toggle-group>
				</div>
			</mat-card-content>
		</mat-card>
	</mtx-popover>

	<!-- CN-8312 V2: client-side sort popover for Engaged + Procured tabs -->
	<mtx-popover #engagedProcuredSortPopover="mtxPopover" [closeOnPanelClick]="false">
		<mat-card class="p-0 primary-border">
			<mat-card-content class="filter_dropdown font-size-14 padding-0-5">
				<div class="m-t-0-5" fxLayout="row">
					<mat-button-toggle-group
						fxFlex
						[ngModel]="engagedProcuredSort"
						(change)="setEngagedProcuredSort($event.value)"
					>
						<mat-button-toggle [value]="RANGE_FILTERS.SORT.MATCH" fxFlex>
							Best Match
						</mat-button-toggle>
						<mat-button-toggle fxFlex [value]="RANGE_FILTERS.SORT.FREQUENCY">
							Frequency
						</mat-button-toggle>
						<mat-button-toggle fxFlex [value]="RANGE_FILTERS.SORT.QUALITY">
							Quality
						</mat-button-toggle>
						<mat-button-toggle fxFlex value="lastContact">
							Last Contacted
						</mat-button-toggle>
						<mat-button-toggle fxFlex value="hasRate">
							Has Rate
						</mat-button-toggle>
					</mat-button-toggle-group>
				</div>
			</mat-card-content>
		</mat-card>
	</mtx-popover>

	<ng-template #projectDetailSkeletonLoader>
		<app-skeleton-loader
			cssClasses="project_details_skeleton_container"
			[SHOW_PANEL]="true"
			[DEFAULT_ROWS_SIZE]="6"
			[DEFAULT_CARDS_SIZE]="1"
			[DEFAULT_COLUMN_SIZE]="4"
		></app-skeleton-loader>
	</ng-template>

	<ng-template #projectFilterSkeletonLoader>
		<div fxLayout="row" fxLayoutGap="1rem" class="m-t-0-5 full-width">
			<div fxFlex>
				<app-skeleton-loader
					cssClasses="project_details_skeleton_container"
					[SHOW_PANEL]="true"
					[DEFAULT_ROWS_SIZE]="1"
					[DEFAULT_CARDS_SIZE]="1"
					[DEFAULT_COLUMN_SIZE]="5"
				></app-skeleton-loader>
			</div>
		</div>
	</ng-template>

	<ng-template #carrierMapSkeletonLoader>
		<app-skeleton-loader
			cssClasses="contaier_height_auto"
			[SHOW_PANEL]="true"
			[DEFAULT_ROWS_SIZE]="3"
			[DEFAULT_CARDS_SIZE]="3"
			[DEFAULT_COLUMN_SIZE]="3"
		></app-skeleton-loader>
	</ng-template>

	<ng-template #pricingSkeletonLoader>
		<div fxLayout="row" fxLayoutGap="1rem">
			<div fxFlex>
				<app-skeleton-loader
					cssClasses="project_details_skeleton_container"
					[SHOW_PANEL]="true"
					[DEFAULT_ROWS_SIZE]="6"
					[DEFAULT_CARDS_SIZE]="1"
					[DEFAULT_COLUMN_SIZE]="2"
				></app-skeleton-loader>
			</div>
			<div fxFlex>
				<app-skeleton-loader
					cssClasses="project_details_skeleton_container"
					[SHOW_PANEL]="true"
					[DEFAULT_ROWS_SIZE]="6"
					[DEFAULT_CARDS_SIZE]="1"
					[DEFAULT_COLUMN_SIZE]="2"
				></app-skeleton-loader>
			</div>
		</div>
	</ng-template>

	<ng-template #notesSkeletonLoader>
		<app-skeleton-loader
			cssClasses="contaier_height_auto"
			[SHOW_PANEL]="true"
			[DEFAULT_ROWS_SIZE]="4"
		>
		</app-skeleton-loader>
	</ng-template>
</div>
